

import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';
import { Link, useHistory } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData, postData, postDataN } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { FixedSizeList as List } from 'react-window';
import axios from 'axios';

function ItemIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const [importDialogOpen, setImportDialogOpen] = useState(false);
    const [fileData, setFileData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const history = useHistory();
    const { isAuthenticated, companyId, branchId, userId, permissions, roleName, token, logout } = useAuth();

    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        fetchtableData();
    }, [isAuthenticated, companyId, branchId, roleName, token, logout]);

    const fetchtableData = async () => {
        fetchData('ItemApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Item Group Details:', error);
                if (error.response && error.response.status === 401) {
                    logout();
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            });
    };

    const handleDelete = async () => {
        deleteData('ItemApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchtableData();
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('ItemApi', `${itemId}`, token)
            .then(() => {
                fetchtableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const openImportDialog = () => {
        setImportDialogOpen(true);
    };

    const closeImportDialog = () => {
        setImportDialogOpen(false);
        setFileData([]);
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            const sheetData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            const rowsToRead = sheetData.slice(1);

            const formattedData = rowsToRead
                .filter(row => row[2])
                .map((row) => {
                    return {
                        Material: row[0] ? String(row[0]) : "",
                        Description: row[1] ? String(row[1]) : "",
                        PG: row[2] ? String(row[2]) : "",
                        IG: row[3] ? String(row[3]) : "",
                        ISG: String(row[4]),
                        PF: row[5] ? String(row[5]) : "",
                        Group: row[6] ? String(row[6]) : "",
                        HSN: row[8] ? String(row[8]) : "",
                        MIKCode: row[9] ? String(row[9]) : "",
                        GST: row[12] ?? 0,
                        MRP: row[7] ?? 0,
                        Category: row[11] ?? 0,
                    };
                });

            setFileData(formattedData);
        };

        reader.readAsArrayBuffer(file);
    };

    const handleImport = async (event) => {
        setIsLoading(true);

        const CreateData = {
            CompanyId: companyId,
            BranchId: branchId,
            CreatedBy: userId,
            ItemImport: fileData
        };

        const url = 'ItemImportApi';
        const baseURL = 'https://mga-api.off-ease.com/api/';
        //const baseURL = 'https://localhost:7069/api/';

        try {
            const response = await axios.post(
                `${baseURL}${url}`,
                CreateData,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            );
            // Handle response here if needed
        } catch (error) {
            console.error('Error importing data:', error);
            // Optionally, handle the error state or notify the user
        } finally {
            setIsLoading(false);
            console.log('Item Imported !');
        }

        // postDataN('ItemApi', '', CreateData, token)
        //     .then((response) => {
        //         setIsLoading(false);
        //         closeImportDialog();
        //         fetchtableData();
        //     })
        //     .catch((error) => {
        //         setIsLoading(false);
        //         console.error('Error importing data:', error);
        //     });
    };


    // postDataN('ItemApi', '', CreateData, token)
    //     .then((response) => {
    //         setIsLoading(false);
    //         closeImportDialog();
    //         fetchtableData();
    //     })
    //     .catch((error) => {
    //         setIsLoading(false);
    //         console.error('Error importing data:', error);
    //     });

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
        setSearchQuery('');
    };

    const filteredData = data.filter((item) =>
        item.Code.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.Name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const Row = ({ index, style }) => {
        const item = filteredData[index];

        return (
            <TableRow key={item.id} style={style} className={item.IsActive ? '' : 'inactiveRow'}
                sx={{
                    '&:hover': {
                        backgroundColor: '#B2DFDB', // Change color on hover
                    },
                }}
            >
                <TableCell sx={{ backgroundColor: 'whitesmoke', borderBottom: '1px solid #C0C0C0', padding: '3px', width: '5%', fontSize: '14px' }}>{index + 1}</TableCell>
                <TableCell sx={{ backgroundColor: 'whitesmoke', borderBottom: '1px solid #C0C0C0', padding: '3px', width: '15%', fontSize: '14px' }}>{item.Code}</TableCell>
                <TableCell sx={{ backgroundColor: 'whitesmoke', borderBottom: '1px solid #C0C0C0', padding: '3px', width: '30%', fontSize: '14px' }}>{item.Name}</TableCell>
                <TableCell sx={{ backgroundColor: 'whitesmoke', borderBottom: '1px solid #C0C0C0', padding: '3px', width: '10%', fontSize: '14px' }}>{item.MRP}</TableCell>
                <TableCell sx={{ backgroundColor: 'whitesmoke', borderBottom: '1px solid #C0C0C0', padding: '3px', width: '10%', fontSize: '14px' }}>{item.DiscountPercentage}</TableCell>
                <TableCell sx={{ backgroundColor: 'whitesmoke', borderBottom: '1px solid #C0C0C0', padding: '3px', width: '10%', fontSize: '14px' }}>{item.GSTRate}</TableCell>
                <TableCell sx={{ backgroundColor: 'whitesmoke', borderBottom: '1px solid #C0C0C0', padding: '3px', width: '10%', fontSize: '14px' }}>{item.HSNCode}</TableCell>
                <TableCell sx={{ backgroundColor: 'whitesmoke', borderBottom: '1px solid #C0C0C0', padding: '3px', width: '10%', fontSize: '14px' }}>
                    {hasEditMasterPermission && (
                        <Link to={`/itemEdit/${item.Id}`}>
                            <IconButton color="primary">
                                <EditIcon style={{ fontSize: '22px' }} />
                            </IconButton>
                        </Link>
                    )}
                    {hasDeleteMasterPermission && (
                        <IconButton onClick={() => openConfirmDialog(item.Id)} color="error">
                            <DeleteIcon style={{ fontSize: '22px' }} />
                        </IconButton>
                    )}
                    {/* {hasDeleteMasterPermission && (
                        <IconButton onClick={() => handleActivate(item.Id)} color="primary">
                            <CheckCircleIcon style={{ height: '22px' }} />
                        </IconButton>
                    )} */}
                </TableCell>
                <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '10%', fontSize: '14px' }}></TableCell>
            </TableRow>
        );
    };

    return (
        <div className="item-index-container">
            <div className="w-full max-w-sm container mt-2 mx-auto">
                <div className='w-full mb-2 flex'>
                    <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Item </h6>
                    <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                        <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                        {showSearchInput && (
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text"
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={handleSearch}
                                style={{ marginLeft: '-30px', width: '200px' }}
                            />
                        )}
                    </div>
                    {hasCreateMasterPermission && roleName === "SuperAdmin" && (
                        <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                            <Button
                                component={Link}
                                to="/ItemCreate"
                                className="linkcolor"
                                style={{ marginLeft: '8px', color: 'orangered', fontWeight: 'bolder' }}
                            >
                                <AddIcon /> CREATE NEW
                            </Button>
                        </div>
                    )}
                    {hasCreateMasterPermission && (
                        <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                            <Button
                                onClick={openImportDialog}
                                style={{ marginLeft: '8px', color: 'brown', fontWeight: 'bolder' }}
                            >
                                <ImportExportIcon style={{ color: 'brown', fontWeight: 'bolder' }} />IMPORT ITEM
                            </Button>
                        </div>
                    )}
                </div>
            </div>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead sx={{ backgroundColor: '#008080', padding: '5px' }}>
                        <TableRow>
                            <TableCell>
                                <span style={{ marginLeft: '-5px', color: 'white', fontWeight: 'bolder' }}>SL NO</span>
                                <span style={{ marginLeft: '45px', color: 'white', fontWeight: 'bolder' }}>CODE</span>
                                <span style={{ marginLeft: '180px', color: 'white', fontWeight: 'bolder' }}>NAME</span>
                                <span style={{ marginLeft: '390px', color: 'white', fontWeight: 'bolder' }}>MRP</span>
                                <span style={{ marginLeft: '100px', color: 'white', fontWeight: 'bolder' }}>DIC %</span>
                                <span style={{ marginLeft: '105px', color: 'white', fontWeight: 'bolder' }}>GST</span>
                                <span style={{ marginLeft: '150px', color: 'white', fontWeight: 'bolder' }}>HSN</span>
                                {/* <span style={{ marginLeft: '110px', color: 'white', fontWeight: 'bolder' }}>Action</span> */}
                            </TableCell>

                        </TableRow>
                    </TableHead>
                    <TableBody sx={{ backgroundColor: '#C3E9E4' }}>
                        <List
                            height={500}
                            itemCount={filteredData.length}
                            itemSize={60}
                            width="100%"
                        >
                            {Row}
                        </List>
                    </TableBody>
                </Table>
            </TableContainer>
            <Dialog open={confirmDialogOpen} onClose={closeConfirmDialog}>
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>Are you sure you want to delete this item?</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeConfirmDialog} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDelete} color="secondary">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={importDialogOpen} onClose={closeImportDialog}>
                <DialogTitle>Import Items</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Upload an Excel file to import items. Ensure the file format is correct.
                    </DialogContentText>
                    <input type="file" onChange={handleFileChange} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeImportDialog} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleImport} color="secondary" disabled={isLoading}>
                        {isLoading ? <CircularProgress size={24} /> : 'Import'}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
export default ItemIndex;